import { useSyncExternalStore } from 'react';
import { player, type PlayerState } from '@/lib/player.ts';

/**
 * Playback state — kind #3.
 *
 * The controller owns the truth; React only reads it. useSyncExternalStore is
 * exactly the right primitive: no duplicated state, no effect syncing two
 * copies, and no chance of React's copy drifting from the media element's
 * actual condition.
 */
export function usePlayer(): PlayerState {
  return useSyncExternalStore(
    (cb) => player.subscribe(() => cb()),
    () => player.getState(),
    () => player.getState(),
  );
}
